import React, { useState } from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
export function SelfAssessmentPage() {
  const [currentStep, setCurrentStep] = useState(1);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const navigate = useNavigate();
  const totalSteps = 2;
  const goToNextStep = () => {
    if (currentStep < totalSteps) {
      setCurrentStep(currentStep + 1);
    } else {
      navigate('/assessment/results');
    }
  };
  const goToPreviousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    } else {
      navigate('/assessment');
    }
  };
  const handleSelect = (option: string) => {
    setAnswers({
      ...answers,
      [currentStep]: option
    });
  };
  const isContinueDisabled = !answers[currentStep];
  return <div className="w-full min-h-screen bg-[#f5f5f7] flex flex-col font-sans text-[#111111]" data-id="element-4923">
      {/* Top Bar */}
      <div className="w-full max-w-md mx-auto px-5 pt-4 pb-2 flex items-center justify-between z-10 relative" data-id="element-4924">
        <div className="w-10" data-id="element-4925">
          <button onClick={goToPreviousStep} className="p-2 -ml-2 rounded-full hover:bg-gray-200 transition-colors text-gray-600 border-0 bg-transparent cursor-pointer" data-id="element-4926">
            <ArrowLeftIcon size={20} data-id="element-4927" />
          </button>
        </div>
        <div className="text-sm font-medium text-gray-500" data-id="element-4928">
          Step {currentStep} of {totalSteps}
        </div>
        <div className="w-10 text-right" data-id="element-4929">
          <button onClick={() => navigate('/assessment/results')} className="text-sm font-medium text-gray-400 hover:text-gray-600 border-0 bg-transparent cursor-pointer p-0" data-id="element-4930">
            Skip
          </button>
        </div>
      </div>

      {/* Progress Bar */}
      <div className="w-full max-w-md mx-auto px-5 mb-4" data-id="element-4931">
        <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-4932">
          <div className="h-full bg-[#631bb7] transition-all duration-300 ease-in-out" style={{
          width: `${currentStep / totalSteps * 100}%`
        }} data-id="element-4933" />
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 w-full max-w-md mx-auto px-5 relative flex flex-col" data-id="element-4934">
        <div className="flex-1 flex flex-col" data-id="element-4935">
          {currentStep === 1 && <>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1F0648] mb-6 leading-tight" data-id="element-4936">
                Do you use a password manager?
              </h2>
              <div className="space-y-3" data-id="element-4937">
                {['Yes, for all my accounts', 'Yes, for some accounts', 'No, I remember them or write them down', "I'm not sure what that is"].map(option => <button key={option} onClick={() => handleSelect(option)} className={`w-full text-left p-4 rounded-2xl border-2 transition-all duration-200 cursor-pointer ${answers[currentStep] === option ? 'border-[#631bb7] bg-[#f5f0ff]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-4938">
                    <span className={`font-bold text-base ${answers[currentStep] === option ? 'text-[#631bb7]' : 'text-[#111111]'}`} data-id="element-4939">
                      {option}
                    </span>
                  </button>)}
              </div>
            </>}

          {currentStep === 2 && <>
              <h2 className="text-2xl md:text-3xl font-bold text-[#1F0648] mb-6 leading-tight" data-id="element-4940">
                Do you use two-factor authentication (2FA)?
              </h2>
              <div className="space-y-3" data-id="element-4941">
                {['Yes, for all important accounts', 'Yes, for some accounts', "No, I don't use it", "I'm not sure what that is"].map(option => <button key={option} onClick={() => handleSelect(option)} className={`w-full text-left p-4 rounded-2xl border-2 transition-all duration-200 cursor-pointer ${answers[currentStep] === option ? 'border-[#631bb7] bg-[#f5f0ff]' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-4942">
                    <span className={`font-bold text-base ${answers[currentStep] === option ? 'text-[#631bb7]' : 'text-[#111111]'}`} data-id="element-4943">
                      {option}
                    </span>
                  </button>)}
              </div>
            </>}
        </div>

        {/* Bottom Continue Button */}
        <div className="mt-auto pt-4 pb-6 bg-[#f5f5f7] z-10 sticky bottom-0" data-id="element-4944">
          <button onClick={goToNextStep} disabled={isContinueDisabled} className={`w-full py-3.5 rounded-xl font-bold text-lg transition-all duration-200 ${!isContinueDisabled ? 'bg-[#631bb7] text-white hover:bg-[#521099] shadow-md cursor-pointer' : 'bg-[#631bb7] text-white opacity-50 cursor-not-allowed'}`} data-id="element-4945">
            Continue
          </button>
        </div>
      </div>
    </div>;
}